module.exports = {
	xAsyncForm: (enableValidation = false) => {
		return {
			validation: enableValidation,
			validated: true,
			submitting: false,
			valid: null,
			text: '',
			submit: function (event) {
				this.text = ''
				this.submitting = true

				var form = event.target.closest("form")

				_self = this;
				if (this.validation) {
					this.validated = window.v.isValid(form)
                }
				
				if (this.validated) {
					fetch(this.$el.action, {
						method: 'POST',
						body: JSON.stringify(Object.fromEntries(new FormData(form))),
						headers: {
							'Content-Type': 'application/json',
						}
					})
					.then(response => response.json())
					.then(function (response) {
						if (response.redirectUrl) {
							window.location.href = response.redirectUrl
						}
						else {
							_self.valid = response.succeeded
							_self.text = response.text
							_self.submitting = false
						}
					})
					.catch(function () {
						_self.submitting = false
						_self.$dispatch('notify', { "text": "Internal server error: 500", "succeeded": false })
					})
				}
				else {
					_self.submitting = false
                }
			}
		}
	}
}